<template>
	<div>
		<div class="text-center">
			<loading :active.sync="isUploading" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1 text-center">{{ $t('Uploading') }} {{uploadProgress}} % ({{fileCount}}/{{fileCountTotal}})</div>
				</template>
			</loading>
			<loading :active.sync="isAdding" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1 text-center">{{ $t('Uploading') }} {{uploadProgress}} % ({{fileCount}}/{{fileCountTotal}})</div>
				</template>
			</loading>
		</div>
	<!-- Gallery -->
	<modal
		wrapper="full"
		size="full"
		class="template-modal popup-modal"
		:hide-footer="true"
		@close="close">
		<!-- <template slot="header">
			<h5 class="mb-0 capitalize">{{ $t('Gallery') }}</h5>
		</template> -->
		<template slot="body">
			<div class="row program-monitor">
				<div class="flex-center-left w-100 mh-35 ml-4">
					<!-- bottom navbar -->
					<div class="flex-center-left floating-bottom-navbar mb-2" v-if="!isFetching">
						<!-- <div v-if="activeRouteName === 'RundownEditor'"
							:class="{ 'active': tab === 'event', 'text-primary': tab === 'event' }"
							@click="goEvent">
							{{ $t('CURRENT RUNDOWN') }}
						</div> -->
						<div class="flex-center">
							<div class="form-group mb-0 w-50 mr-3">
								<md-menu md-align-trigger md-direction="top-start">
									<div md-menu-trigger>
										<custom-input
											type="select"
											align="left"
											class="form-control cur-p relative min-w200px"
											:value="rundownFilterLabel"
										/>
									</div>
									<md-menu-content id="scrolls-style">
										<md-menu-item class="item-property-rundown min-w200px" v-for="item in rundownList" @click="rundownFilterUpdate(item.id)"
										:key="item.key">{{item.name}}</md-menu-item>
									</md-menu-content>
								</md-menu>
							</div>
						</div>
						<!-- <div
							v-if="!isVirtualCam"
							class="pointer"
							:class="{ 'active': tab === 'all', 'text-primary': tab === 'all',
								'mr-5': (rundownItem && rundownItem.type === 'lottie')
								|| (rundownItem && rundownItem.type === 'audio')
								|| (rundownItem && rundownItem.type === 'lower_third')
								|| activeRouteName === 'CompositionEditorNew'
								|| activeRouteName  === 'CompositionEditorUpdate',
								'ml-5': activeRouteName === 'RundownEditor'
								}"
								@click="tab = 'all'">
							{{ $t('ALL') }}
						</div>
						<div
							v-if="(rundownItem && rundownItem.type !== 'lottie')
								&& (rundownItem && rundownItem.type !== 'audio')
								&& (rundownItem && rundownItem.type !== 'lower_third')
								|| (activeRouteName !== 'RundownEditor'
								&& activeRouteName !== 'CompositionEditorNew'
								&& activeRouteName !== 'CompositionEditorUpdate')"
							class="ml-5 mr-2 pointer"
							:class="{ 'active': tab === 'image', 'text-primary': tab === 'image' }"
							@click="goImage">
							{{ $t('IMAGE') }}
						</div>
						<div
							v-if="(rundownItem && rundownItem.type !== 'lottie')
								&& (rundownItem && rundownItem.type !== 'audio')
								&& (rundownItem && rundownItem.type !== 'lower_third')
								&& !isVirtualCam
								|| (activeRouteName !== 'RundownEditor'
								&& activeRouteName !== 'CompositionEditorNew'
								&& activeRouteName !== 'CompositionEditorUpdate') "
							class="ml-5 pointer"
							:class="{ 'active': tab === 'video', 'text-primary': tab === 'video', 'mr-5': rundownItem && rundownItem.type !== 'lottie'}"
							@click="goVideo">
							{{ $t('VIDEO') }}
						</div> -->
						<!-- label on admin -->
						<!-- <div
							class="ml-5 mr-5 pointer"
							v-if="activeRouteName !== 'RundownEditor'
								&& activeRouteName !== 'CompositionEditorNew'
								&& activeRouteName !== 'CompositionEditorUpdate'"
							:class="{ 'active': tab === 'lottie', 'text-primary': tab === 'lottie' }"
							@click="goLottie">
							{{ $t('LOTTIE') }}
						</div>
						<div
							class="mr-5 pointer"
							v-if="activeRouteName !== 'RundownEditor'
								&& activeRouteName !== 'CompositionEditorNew'
								&& activeRouteName !== 'CompositionEditorUpdate'"
							:class="{ 'active': tab === 'audio', 'text-primary': tab === 'audio' }"
							@click="goAudio">
							{{ $t('AUDIO') }}
						</div> -->
						<!-- Search Keyword -->
						<div class="relative">
							<i class="material-icons wrapper-search-input ml-2">search</i>
							<input
								type="text"
								class="form-control search-input"
								:placeholder="$t('Search Media')"
								@input="onKeywordChange"
								v-model="keyword"
							/>
						</div>
						<!-- filtering -->
						<div
							class="pointer ml-5 mr-4 uppercase" @click="sortRecent" :class="{'text-primary': orderBy === 'created_at'}">
							{{ $t('Recent') }}
						</div>
						<div
							class="pointer mr-4 uppercase" @click="sortAlphabetical" :class="{'text-primary': orderBy === 'name'}">
							{{ $t('Alphabetical') }}
						</div>
						<div v-if="isSuperAdmin"
							class="pointer mr-4 uppercase" @click="filterByAdmin" :class="{'text-primary': isByAdmin}">
							{{ $t('By Admin') }}
						</div>
						<!-- select -->
						<div class="mb-3 ml-a" v-if="selected && (activeRouteName === 'RundownEditor' || activeRouteName === 'RundownCommandEditor' || activeRouteName === 'CompositionEditorNew' || activeRouteName === 'CompositionEditorUpdate') ">
							<button
								v-if="selected"
								type="button"
								class="btn btn-primary mb-0 ml-a mr-3 mt-3"
								@click="dblCliclSelectItem(selected)">
								{{ $t('select') }}
							</button>
						</div>
						<!-- delete -->
						<div @click="isConfirmRemoveVisible = true">
							<div v-if="isShowDelete">
								<label
									v-tooltip.bottom-end="$t('Delete Media')"
									class="btn btn-danger btn-icon ml-2 button-upload-lottie-gallery btn-gallery-small">
									<i class="material-icons md-18">delete</i>
								</label>
							</div>
						</div>
						<!-- upload thumbnail -->
						<div v-if="(selected && user.roles.includes('super_admin') && (selected && selected.type !== 'audio')) || (selected && selected.user_id === user.id) && (selected && selected.type !== 'audio')" :class="{ 'disabled': isUploadingThumbnail }">
							<label
								v-tooltip.bottom-end="$t('Upload Thumbnail')"
								class="btn btn-primary btn-icon ml-3 button-upload-lottie-gallery btn-gallery-small">
								<span class="text-black" :class="{ 'is-loading': isUploadingThumbnail }"><image-outline></image-outline></span>
								<input
									id="thumbnailInput"
									type="file"
									accept=".png,.gif,.jpeg,.jpg"
									class="hidden"
									@change="onFileThumbnailSelected"
								/>
							</label>
						</div>
						<!-- download -->
						<div @click="downloadMedia(selected.path)">
							<div v-if="(selected && user.roles.includes('super_admin') && (selected && selected.type === 'image' || selected.type === 'video' || selected.type === 'audio')) || (selected && selected.user_id === user.id ) && (selected && selected.type === 'image' || selected.type === 'video' || selected.type === 'audio')">
								<label
									v-tooltip.bottom-end="$t('Download Media')"
									class="btn btn-primary btn-icon ml-2 button-upload-lottie-gallery btn-gallery-small">
									<span class="text-black"><download></download></span>
								</label>
							</div>
						</div>
						<!-- upload asset lottie -->
						<div>
							<div v-if="(selected && user.roles.includes('super_admin')) && (selected && selected.type === 'lottie')">
								<label
									v-tooltip.bottom-end="$t('Upload Assets')"
									class="btn btn-primary btn-icon ml-2 button-upload-lottie-gallery btn-gallery-small">
									<span class="text-black"><upload></upload></span>
									<input
										id="assetsInput"
										type="file"
										accept=".zip"
										class="hidden"
										@change="onFileAssetSelected"
									/>
								</label>
							</div>
						</div>
						<!-- Assign to user -->
						<div @click="openModalAssignUser(selected)">
							<div v-if="(selected && user.roles.includes('super_admin')) && (user && selected.user_id === user.id)">
								<label
									v-tooltip.bottom-end="$t('Assign to user')"
									class="btn btn-primary btn-icon ml-2 button-upload-lottie-gallery btn-gallery-small">
									<i class="material-icons md-18">people</i>
								</label>
							</div>
						</div>
					</div>
					<!-- upload -->
					<div
						class="pointer text-upload-gallery">
						<label
							class="mb-0 ml-a mr-3 pointer">
							<span>{{ $t('UPLOAD MEDIA') }}</span>
							<input
								v-if="(rundownItem && rundownItem.type !== 'lottie') && (rundownItem && rundownItem.type !== 'lower_third') && (rundownItem && rundownItem.type !== 'audio') || (activeRouteName !== 'RundownEditor' || activeRouteName !== 'RundownCommandEditor')"
								id="mediaInput"
								accept=".json,.png,.gif,.jpeg,.jpg,.mp4,.mpg,.m4v,.webm,.mp3,.ogg,.wav"
								type="file"
								class="hidden"
								multiple
								@change="fileMultipleUpload"
							/>
							<input
								v-if="rundownItem && rundownItem.type === 'lottie'"
								accept=".json"
								id="mediaInput"
								type="file"
								class="hidden"
								multiple
								@change="fileMultipleUpload"
							/>
							<input
								v-if="rundownItem && rundownItem.type === 'lower_third'"
								accept=".png,.gif,.jpeg,.jpg"
								id="mediaInput"
								type="file"
								class="hidden"
								multiple
								@change="fileMultipleUpload"
							/>
							<input
								v-if="rundownItem && rundownItem.type === 'audio'"
								accept=".mp3,.ogg,.wav"
								id="mediaInput"
								type="file"
								class="hidden"
								multiple
								@change="fileMultipleUpload"
							/>
						</label>
					</div>
					<!-- category -->
					<div ref="scrollCategory" class="form-group mb-3 mt-3 ml-4 d-flex scrolling-horizontal-menu uppercase" v-if="!isAudio">
						<div class="mr-2" v-for="item in categories" :key="item.id">
							<div class="category-gallery nowrap pointer"  :class="{'category-gallery-active': categoryId && item.id === categoryId}" @click="selectedCategory(item)">{{item.name}}</div>
						</div>
						<!-- <select
							name="size"
							class="form-control category-template-input"
							required
							@change="selectedCategory(category)"
							v-model="category">
							<option
								v-for="item in categories"
								:key="item.id"
								:value="item.id">
								{{ item.name }}
							</option>
						</select> -->
					</div>
				</div>
				<!-- Button Action -->
				<div class="col-md-8">
					<div class="w-100">
					<div class="tab-contents">
					<!-- Loader -->
						<div>
							<div class="p-5 text-center top-50p absolute z-index-99 left50" v-if="isFetching && tab !== 'store'">
								<div class="is-loading large loader-popup"></div>
							</div>
						</div>
						<!-- Gallery Grid -->
							<div class="template-editor-wrapper relative" v-if="tab === 'event' || tab === 'all' || tab === 'image' || tab === 'video' || tab === 'lottie' || tab === 'audio'">
								<div class="d-flex justify-content-between">
									<div v-if="!isAudio" @click="scroll_left" style="margin-top: -3em; margin-left: -5px; position: absolute">
										<svg class="icon-chevron ml-0" style="width:24px;height:24px" viewBox="0 0 24 24">
											<path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
										</svg>
									</div>
									<div v-if="!isAudio" @click="scroll_right" style="margin-top: -3em; margin-left: -5px; position: absolute; right: 0;">
										<svg class="icon-chevron" style="width:24px;height:24px" viewBox="0 0 24 24">
											<path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
										</svg>
									</div>
								</div>
								<transition name="fade">
								<div @scroll="lazyLoad" class="templates template-editor-item" id="styleScroll">
									<div
										class="template d-block"
										:class="{ 'active': selected && selected.id === media.id,
										'template': activeRouteName === 'RundownEditor' || activeRouteName === 'CompositionEditorNew' || activeRouteName === 'RundownCommandEditor',
										'template-low': activeRouteName !== 'RundownEditor' || activeRouteName !== 'CompositionEditorNew' || activeRouteName !== 'RundownCommandEditor'}"
										v-for="media in items"
										:key="media.id"
										@dblclick="dblCliclSelectItem(media)"
										@click="selectItem(media)">
										<div class="d-flex justify-content-between relative">
											<div v-if="media.type ==='image'" class="thumbnail-gallery">
												<gallery-popup-image-thumbnail :media="media"/>
											</div>
											<div v-if="media.type ==='lottie'" class="thumbnail-gallery">
												<div class="absolute ml-2 pt-1" style="opacity: .8">
													<svg style="width:24px;height:24px" viewBox="0 0 26 26">
														<svg style="width:24px;height:24px" viewBox="0 0 24 24">
															<path fill="#00ff00" d="M15,2A7,7 0 0,1 22,9C22,11.71 20.46,14.05 18.22,15.22C17.55,16.5 16.5,17.55 15.22,18.22C14.05,20.46 11.71,22 9,22A7,7 0 0,1 2,15C2,12.29 3.54,9.95 5.78,8.78C6.45,7.5 7.5,6.45 8.78,5.78C9.95,3.54 12.29,2 15,2M12,19A7,7 0 0,1 5,12C4.37,12.84 4,13.87 4,15A5,5 0 0,0 9,20C10.13,20 11.16,19.63 12,19M15,16A7,7 0 0,1 8,9H8C7.37,9.84 7,10.87 7,12A5,5 0 0,0 12,17C13.13,17 14.16,16.63 15,16V16M15,4C13.87,4 12.84,4.37 12,5V5A7,7 0 0,1 19,12H19C19.63,11.16 20,10.13 20,9A5,5 0 0,0 15,4M10,9A5,5 0 0,0 15,14C15.6,14 16.17,13.9 16.7,13.7C16.9,13.17 17,12.6 17,12A5,5 0 0,0 12,7C11.4,7 10.83,7.1 10.3,7.3C10.1,7.83 10,8.4 10,9Z" />
														</svg>
													</svg>
												</div>
												<!-- loading -->
												<gallery-popup-image-thumbnail :media="media"/>
											</div>
											<div v-if="media.type === 'video'" class="thumbnail-gallery">
												<div class="absolute ml-2 pt-1" style="opacity: .8">
													<svg style="width:24px;height:24px" viewBox="0 0 26 26">
														<path fill="#0000ff" d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
													</svg>
												</div>
												<!-- loading -->
												<gallery-popup-image-thumbnail :media="media"/>
												<!-- <video preload="metadata" class="thumbnail-gallery relative">
													<source :src="media.thumbnail" type="video/mp4">
												</video> -->
												<!-- <span class="video-name absolute text-white truncate-media-name">{{ media.name }}</span> -->
											</div>
											<div v-if="media.type ==='audio'" class="thumbnail-gallery">
												<div style="width: 160px; height: 90px; background-color: black; padding-left: 35%; padding-top: 10%;">
													<music-icon :size="48"></music-icon>
												</div>
											</div>
											<div>
											<!-- <div class="absolute thumbnail-gallery" style="background-color: black; opacity: 0.7;" v-if="media.path === urlDonwload && isDownloading && tab !== 'store'"></div>
												<div class="p-3 text-center absolute z-index-99" style="left:25%"  v-if="media.path === urlDonwload && isDownloading && tab !== 'store'">
													<div class="is-loading large loader-popup"></div>
												</div> -->
											</div>
											<!-- <div class="p-3 top-50p text-center capitalize mt-2 absolute z-index-99" v-if="media.path === urlDonwload && isDownloading && tab !== 'store'">Downloading...</div> -->
										</div>
										<div
											:class="{'template-btn-select': media.type === 'image', 'template-btn-select-video': media.type === 'video', 'template-btn-select-lottie': media.type === 'lottie', 'template-btn-select-audio': media.type === 'audio' }"
											class="truncate-media-name uppercase">
											{{ regexNameExtension(media.name) }}
										</div>
									</div>
								</div>
								</transition>
							</div>
							<div v-if="tab === 'store'" class="template-editor-wrapper text-center mt-6">
								<div >
									<h4>{{$t('Stay Tuned')}}</h4>
								</div>
							</div>
							<div v-if="items.length <= 0 && !isFetching" class="template-editor-wrapper text-center">
								<div>
									<h4>{{$t('No Available Media')}}</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div @click="close"  class="modal-close-media-template">
						<i class="material-icons font15">close</i>
				</div>
				<!-- preview -->
				<div class="col-md-4 pt-2 category-filter pr-3 pl-0 text-center relative" id="styleScroll">
					<!-- preview lottie -->
					<div v-show="selected && selected.type ? selected.type === 'lottie' : ''" class="preview-template2 mb-3">
						<TemplatePreview ref="templatePreview" class="preview-template2" :lottieTemplate="activeLottie"/>
					</div>
					<div v-if="selected && selected.type ? selected.type === 'image' : ''" class="preview-gallery mb-3">
						<img :src="selected.path" class="thumbnail-gallery-preview absolute preview-media-type" alt="Grafias">
					</div>
					<div v-if="selected && selected.type ? selected.type === 'video' : ''" class="preview-gallery mb-3 relative">
						<video autoplay :src="selected.path" controls preload="metadata" class="thumbnail-gallery-preview absolute preview-media-type"></video>
					</div>
					<div v-if="selected && selected.type ? selected.type === 'audio' : ''" class="preview-gallery mb-3 relative">
						<video autoplay :src="selected.path" controls preload="metadata" class="thumbnail-gallery-preview absolute preview-media-type"></video>
					</div>
					<div v-if="!selected" class="preview-gallery mb-3"></div>
					<!-- button -->
					<div class="mb-3" v-if="selected && (activeRouteName === 'RundownEditor' || activeRouteName === 'RundownCommandEditor' || activeRouteName === 'CompositionEditorNew' || activeRouteName === 'CompositionEditorUpdate') ">
						<button
							v-if="selected && selected.type ? selected.type === 'image' : ''"
							type="button"
							class="btn btn-primary w-100"
							@click="dblCliclSelectItem(selected)">
							{{ $t('Select Image') }}
						</button>
						<button
							v-if="selected && selected.type ? selected.type === 'video' : ''"
							type="button"
							class="btn btn-primary w-100"
							@click="dblCliclSelectItem(selected)">
							{{ $t('Select Video') }}
						</button>
						<button
							v-if="selected && selected.type ? selected.type === 'lottie' : ''"
							type="button"
							class="btn btn-primary w-100"
							@click="dblCliclSelectItem(selected)">
							{{ $t('Select Lottie') }}
						</button>
						<button
							v-if="selected && selected.type ? selected.type === 'audio' : ''"
							type="button"
							class="btn btn-primary w-100"
							@click="dblCliclSelectItem(selected)">
							{{ $t('Select Audio') }}
						</button>
					</div>
					<h4 v-if="selected" class="text-white text-left uppercase mb-5">{{ selected && selected.name ? selected.name : '' }}</h4>
					<div v-if="selected" class="text-left capitalize mb-4">
						<div class="d-flex mb-3">
							<svg class="mr-3" style="width:27;height:27" viewBox="0 0 22 22">
								<path fill="#717171" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z" />
							</svg>
							<div class="mt-1 text-white">{{selected && selected.user && selected.user.name ? selected.user.name: 'User Has Been Deleted'}}</div>
						</div>
						<div class="d-flex">
							<svg class="mr-3" style="width:27;height:27" viewBox="0 0 22 22">
								<path fill="#717171" d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
							</svg>
							<div class="mt-1 text-white">({{ convertSize(selected && selected.size) }}) {{dateFormat(selected && selected.created_at)}}</div>
						</div>
					</div>
					<!-- show media info -->
					<div v-html="getMediaInfo(selected)" v-if="!isGettingMediaInfo && selected && selected.content" class="mh-20 text-left"></div>
					<div class="d-flex ml-2">
						<div :class="{'is-loading': isGettingMediaInfo}"></div>
						<div v-if="isGettingMediaInfo && selected" class="text-secondary ml-4">Getting Media info...</div>
					</div>
					<!-- desctription -->
					<div v-if="selected" @blur="saveDescription">
						<hr v-if="selected && selected.description || selected.user_id === user.id">
						<div class="d-flex justify-content-between" v-if="selected && selected.description || selected.user_id === user.id">
							<h4>Description</h4>
							<i class="material-icons md-18 pointer" v-tooltip="'Edit description'" @click.stop="isEditDescription = true" v-if="!isEditDescription && selected.user_id === user.id">edit</i>
						</div>
						<div class="relative" v-if="selected && selected.description || selected.user_id === user.id">
							<div class="ml-1 text-left absolute" v-if="!isEditDescription && !selected.description">-</div>
							<textarea @blur="saveDescription" :class="{'textarea-feedback': isEditDescription, 'textarea-idle': !isEditDescription, 'disabled': selected.user_id !== user.id}" @click="isEditDescription = true" rows="8" v-model="selected.description"></textarea>
						</div>
						<transition name="fade">
							<button
								v-if="selected && isEditDescription"
								type="button"
								class="btn btn-primary w-100 mt-2"
								@click="saveDescription">
								{{ $t('Update Description') }}
							</button>
						</transition>
					</div>
				</div>
			</div>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				class="template-modal gallery-modal-delete"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{showModalName(selected ? selected.name : '') }}?</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="remove">
							{{ $t('Yes, Delete It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<div v-if="isSuperAdmin">
				<modal-assign-user :titleAssignModal="'media'" :data="dataMediaToAssign" :isShowAssign="isShowAssign" @close="isShowAssign = false"/>
			</div>
		</template>
		<!-- Upload Item -->
	</modal>
	<!-- Same File Upload -->
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import ImageOutline from 'vue-material-design-icons/ImageOutline.vue';
import ClickOutside from 'vue-click-outside';
import Download from 'vue-material-design-icons/Download.vue';
import Upload from 'vue-material-design-icons/Upload.vue';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters, mapActions } from 'vuex';
import { Video } from 'video-metadata-thumbnails';
import localforage from 'localforage';
import MusicIcon from 'vue-material-design-icons/Music.vue';
import Modal from '@/components/Modal.vue';
import ModalAssignUser from '@/components/ModalAssignUser.vue';
import TemplatePreview from '@/components/TemplatePreview.vue';
import GalleryPopupImageThumbnail from '@/components/GalleryPopupImageThumbnail.vue';
import CustomInput from '@/components/CustomInput.vue';
import {
	getAxiosErrorMessage,
	duplicateVar,
	delay,
	elpisisString,
	randomString,
	getVideoBlob,
	dateFormat,
} from '@/lib/helper';
import rundownsApi from '@/api/rundowns';
import mediasApi from '@/api/medias';
import authApi from '@/api/auth';
import fileApi from '@/api/file';
import categoriesApi from '@/api/categories';

export default {
	name: 'GalleryPopup',
	props: {
		rundown: {
			type: Object,
		},
		rundownItem: {
			type: Object,
		},
	},
	components: {
		Modal,
		Loading,
		TemplatePreview,
		ImageOutline,
		Download,
		Upload,
		GalleryPopupImageThumbnail,
		ModalAssignUser,
		MusicIcon,
		CustomInput,
	},
	directives: {
		ClickOutside,
	},
	data() {
		return {
			tab: 'event', // event, all
			page: 1,
			limit: 100,
			orderBy: 'created_at',
			sortBy: 'desc',
			keyword: '',
			items: [],
			selected: null,
			isFetching: false,
			isUploading: false,
			uploadProgress: 0,
			mediaUrl: '',
			mediaFile: null,
			mediaLabel: '',
			mediaThumbnail: '',
			category: 1,
			categoryMedia: '',
			isAdding: false,
			isDeleting: false,
			categories: [],
			isSelectedCategory: false,
			categoryId: -10,
			rundownMedia: '',
			isUploadModal: false,
			isShowDelete: false,
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			// multiple upload
			fileCount: 0,
			fileCountTotal: 0,
			tmpCount: 0,
			activeLottie: '',
			isConfirmRemoveVisible: false,
			fileSize: null,
			lastPage: 0,
			bottom: false,
			limitLazyload: 48,
			isFileDonwload: false,
			isDownloading: false,
			urlDonwload: false,
			assetsUrl: null,
			userClient: {},
			isUploadingThumbnail: false,
			smallButton: false,
			// caching
			cachingText: 'Loading ',
			totalCached: 0,
			cancelRequest: null,
			cancelRequestArray: [],
			cancelActive: false,
			showLoadingScreen: true,
			counter: 0,
			// storage warn
			isStorage99Percent: false,
			isStorage80Percent: false,
			currentStorage: false,
			availableStorage: false,
			// assign to user
			isShowAssign: false,
			dataMediaToAssign: {},
			// get rundown
			rundownList: null,
			rundownFilter: 0,
			isEnableAdvance: false,
			isEnableDummy: true,
			isEnableAllPreview: false,
			isEnableShowLogo: false,
			lastCategoryTemplate: 0,
			lastKeywordTemplate: '',
			lastCategoryGallery: 0,
			lastKeywordGallery: '',
			lastRundownGallery: 0,
			isShowTour: false,
			isByAdmin: false,
			// description
			isEditDescription: false,
			description: '',
			// video spec checker
			isNotOptimizedPlayback: false,
			notOptimizedStatus: '',
			isGettingMediaInfo: false,
			mediaKeyId: null,
			warningMedia: '',
			isClosed: false,
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		onCancel() {
			if (this.cancelRequest) {
				this.cancelRequest();
				for (let index = 0; index < this.cancelRequestArray.length; index++) {
					const cancelRequest = this.cancelRequestArray[index];
					cancelRequest();
				}
				this.cancelActive = true;
				this.initScreen();
			}
		},
		showUploadModal() {
			this.isUploadModal = true;
		},
		lazyLoad(e) {
			const { target } = e;
			if (this.page < this.lastPage) {
				if (Math.ceil(target.scrollTop) >= (target.scrollHeight - target.offsetHeight)) {
					this.bottom = true;
					this.page++;
					this.fetch(false, true);
				}
			}
		},
		close() {
			this.$emit('close');
			this.uploadLimit = '';
			this.isEnableUploadLimit = false;
		},
		fetch(reset = false, isLazyLoad) {
			// condition limit for various screen
			const widthScreen = window.innerWidth;
			if (widthScreen <= 1920) {
				this.limitLazyload = 48;
				if (window.innerHeight > 1000) this.limitLazyload = 65;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 1920 && widthScreen > 1920) {
				this.limitLazyload = 60;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 2400 && widthScreen > 2000) {
				this.limitLazyload = 70;
				if (window.innerHeight > 1150) this.limitLazyload = 80;
			} else if (widthScreen <= 2600 && widthScreen > 2000) {
				this.limitLazyload = 80;
			} else if (widthScreen <= 2900 && widthScreen > 2000) {
				this.limitLazyload = 100;
			} else if (widthScreen <= 3440 && widthScreen > 2900) {
				this.limitLazyload = 120;
			} else if (widthScreen <= 4096 && widthScreen > 3440) {
				this.limitLazyload = 150;
			}
			// coding fetch begin
			this.isFetching = true;
			this.selected = null;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			let type = '';

			if (this.rundownItem) {
				type = this.rundownItem.type;
			}

			// eslint-disable-next-line
			if (this.tab === 'all' || 'event') {
				type = '';
			}
			if (this.activeRouteName === 'CompositionEditorUpdate') {
				type = 'image';
			}
			if ((this.rundownItem && this.rundownItem.type ? this.rundownItem.type : '') === 'virtual_cam') { // when rundown item type is virtual cam
				type = 'image';
			}
			const params = {
				page: this.page,
				limit: this.limitLazyload,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				type,
			};
			if (this.categoryId === -10 || !this.categoryId) params.category_id = '';
			if (this.categoryId !== -10) params.category_id = this.categoryId;
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			if (this.tab === 'image') params.type = 'image';
			if (this.tab === 'video') params.type = 'video';
			if (this.tab === 'lottie') params.type = 'lottie';
			if (this.tab === 'audio') params.type = 'audio';
			if (this.rundownItem && this.rundownItem.type === 'video') params.not_type = ['lottie', 'audio'];
			if (this.rundownItem && this.rundownItem.type === 'image') params.not_type = ['lottie', 'audio'];
			if (this.rundownItem && this.rundownItem.type === 'lottie') params.type = 'lottie';
			if (this.rundownItem && this.rundownItem.type === 'audio') params.type = 'audio';
			if (this.rundownItem && this.rundownItem.type === 'lower_third') params.type = 'image';
			if (this.rundownItem && this.rundownItem.type === 'virtual_cam') params.not_type = 'lottie';
			if (this.activeRouteName === 'CompositionEditorUpdate') params.type = 'image';
			if (this.activeRouteName === 'CompositionEditorNew') params.type = 'image';
			// if (this.activeRouteName === 'RundownEditor') {
			if (this.rundownFilter) {
				if (this.rundownFilter !== -10) {
					params.rundown_id = this.rundownFilter;
				} else {
					params.rundown_id = '';
				}
			} else {
				params.rundown_id = this.rundown.id;
			}
			if (this.isByAdmin) params.role = this.isByAdmin;
			// } else {
			// 	// eslint-disable-next-line
			// 	if (this.rundownFilter) {
			// 		if (this.rundownFilter !== -10) {
			// 			params.rundown_id = this.rundownFilter;
			// 		} else {
			// 			params.rundown_id = '';
			// 		}
			// 	} else {
			// 		params.rundown_id = '';
			// 	}
			// }
			const callback = (response) => {
				const medias = response.data;
				this.lastPage = response.lastPage;
				if (isLazyLoad) {
					this.insertItems(medias);
				} else {
					this.items = medias;
				}
				this.isFetching = false;
				params.type = '';
				if (this.counter === 0) {
					if (medias.length === 0) {
						this.rundownFilter = -10;
					}
				}
				this.startCache();

				this.counter++;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Gallery Media',
					text: message,
				});
				this.isFetching = false;
			};
			mediasApi.getList(params, callback, errorCallback);
		},
		startCache() {
			const medias = this.items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie')));
			// If no media (image or video)
			// if (medias.length === 0) this.initScreen();
			// Cache
			this.cachingText = `Loading media 0/${medias.length}`;
			for (let index = 0; index < medias.length; index++) {
				if (this.cancelActive) return;
				this.cachingText = `Loading media ${this.totalCached}/${medias.length}`;
				const item = medias[index];
				const contentId = item.id;
				const itemKey = `thumbnail_${contentId}`;

				// if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `thumbnail_${content.id}`;
				// if (item.type === 'lottie' && content && content.id) itemKey = `thumbnail_${content.id}`;
				// eslint-disable-next-line no-loop-func
				localforage.getItem(itemKey, (err, value) => {
					if (value) {
						// logic when no value
					} else {
						const itemMediaThumbnail = item && item.thumbnail ? item.thumbnail : item.thumbnail;
						const itemMediaName = item && item.name ? item.name : 'media';
						if (itemMediaThumbnail && (item.type === 'image' || item.type === 'video' || item.type === 'lottie')) {
							this.cacheFile(itemKey, itemMediaThumbnail, itemMediaName);
						}
					}
				});
			}
		},
		cacheFile(galleryKey, itemMediaPath, itemMediaName) {
			// get media assets as blob....
			try {
				const cancelCallback = (c) => {
					this.cancelRequest = c;
					this.cancelRequestArray.push(c);
				};
				getVideoBlob(itemMediaPath, cancelCallback).then((blob) => {
					// Check videoBlob
					if (this.cancelActive) return;
					if (!blob) return;
					// Set key and blob
					localforage.setItem(galleryKey, blob, (err, value) => {
						if (!err && value) {
							// handle success cache here
						}
						if (err) {
							this.$notify({
								duration: 6000,
								closeOnClick: true,
								group: 'app',
								type: 'error',
								title: 'Error loading media',
								text: 'Something went wrong please contact admin!',
							});
						}
					});
				}).catch(() => {
					// error handling logic
					const message = `File or Media not found : ${itemMediaName}`;
					this.$notify({
						duration: 9000,
						closeOnClick: true,
						group: 'app',
						type: 'error',
						title: 'Error loading media',
						text: message,
					});
				});
			} catch (e) {
				// catch some error here
			}
		},
		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.items.push(item);
			}
		},
		fileMultipleUpload(e) {
			const files = e.target.files;
			this.fileCountTotal = files.length;
			for (let index = 0; index < files.length; index++) {
				const element = files[index];
				this.onFileSelected(element);
			}
		},
		onFileSelected(fileItem) {
			this.initDataUser();
			this.availableStorage = 0;
			this.currentStorage = 0;
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048;
			}
			const fileSizeInMb = fileItem.size / oneMB;
			const oneGB = 1048;
			// upload
			if (fileItem.type === 'image/jpeg' || fileItem.type === 'image/gif' || fileItem.type === 'image/png' || fileItem.type === 'image/jpg' || fileItem.type === 'video/mp4' || fileItem.type === 'video/mpg'
				|| fileItem.type === 'video/m4v' || fileItem.type === 'application/json' || fileItem.type === 'video/webm' || fileItem.type === 'audio/mpeg' || fileItem.type === 'audio/wav' || fileItem.type === 'audio/ogg') {
				if (fileSizeInMb <= oneGB) {
					if (fileSizeInMb <= this.uploadLimit) {
						// if inside rundown
						if (this.rundownStorage && !this.isSuperAdmin && !this.activeRouteName.includes('CompositionEditor')) {
							const resultSizeFile = fileItem.size / oneMB;
							const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= resultSizeFile;
							const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
							// automatically reject, over limit
							if (!isRemainingStorageAvailable) {
								const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
								this.$notify({
									group: 'app',
									type: 'warning',
									title: 'Upload Media',
									text: message,
								});
								// files = null;
								this.isCached = false;
								this.isCaching = false;
								if (document.querySelector('#mediaInput')) document.querySelector('#mediaInput').value = '';
								return;
							}
						// eslint-disable-next-line no-else-return
						}
						// if outside rundown (composition)
						if (this.rundownStorage && !this.isSuperAdmin && this.activeRouteName.includes('CompositionEditor')) {
							console.log('test');
							const resultSizeFile = fileItem.size / oneMB;
							const isRemainingStorageAvailable = this.userStorage.total_remaining >= 0 && this.userStorage.total_remaining >= resultSizeFile;
							const nomalizedTotalRemaining = this.userStorage.total_remaining <= 0 ? 0 : this.userStorage.total_remaining;
							// automatically reject, over limit
							if (!isRemainingStorageAvailable) {
								const message = `Your total used Storage is ${this.userStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
								this.$notify({
									group: 'app',
									type: 'warning',
									title: 'Upload Media',
									text: message,
								});
								// files = null;
								this.isCached = false;
								this.isCaching = false;
								if (document.querySelector('#mediaInput')) document.querySelector('#mediaInput').value = '';
								return;
							}
						// eslint-disable-next-line no-else-return
						}
						// start upload
						if (!this.items.some(data => data.name === fileItem.name) && !this.items.some(data => data.size === fileItem.size)) {
							const file = fileItem;
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							// check media info
							let contentMedia = '';
							const getSize = () => file.size;
							const readChunk = (chunkSize, offset) => new Promise((resolve, reject) => {
								const reader = new FileReader();
								reader.onload = (event) => {
									if (event.target.error) {
										reject(event.target.error);
									}
									resolve(new Uint8Array(event.target.result));
								};
								reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
							});
							// eslint-disable-next-line no-undef
							MediaInfo({ format: 'JSON' }, (mediainfo) => {
								mediainfo.analyzeData(getSize, readChunk)
									.then((result) => {
										const info = result && result.length > 0 ? JSON.parse(result) : null;
										const tracks = info && info.media && info.media.track ? info.media.track : null;
										const trackIndex = tracks.findIndex(track => track['@type'] === 'Video');
										if (trackIndex !== -1) {
											const mb5 = 5000000; /* 5Mbps */
											if ((tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
												this.$notify({
													group: 'app',
													type: 'warning',
													text: 'Video is exceeding the recommended limit for Web Playback, recomended bitrate is lower than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
													duration: 99999,
												});
												contentMedia = 'Video is exceeding the recommended limit for Web Playback, recomended bitrate is lower than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
											} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
												this.$notify({
													group: 'app',
													type: 'warning',
													text: 'Video is larger than 1920 x 1080, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
													duration: 99999,
												});
												contentMedia = 'Video is larger than 1920 x 1080, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
											} else if ((tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
												this.$notify({
													group: 'app',
													type: 'warning',
													text: 'Video is larger than 1920 x 1080 and bitrate is larger than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
													duration: 99999,
												});
												contentMedia = 'Video is larger than 1920 x 1080 and bitrate is larger than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
											} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
												// when track is valid
												contentMedia = 'No performance issue';
											}
										}
									})
									.catch(() => {
										this.$notify({
											group: 'app',
											type: 'error',
											text: 'cannot read your video meta data info',
										});
									});
							});
							this.isUploading = true;
							this.mediaFile = file;
							// Remove extension from filename to set label
							const filename = duplicateVar(file.name);
							const filenameFinal = filename.split('.').slice(0, -1).join('.');
							const fileSize = file.size;
							this.mediaLabel = duplicateVar(filename);
							let filetype = 'image';
							if (file.type.includes('video')) {
								filetype = 'video';
							} else if (file.type.includes('image')) {
								filetype = 'image';
							} else if (file.type.includes('json')) {
								filetype = 'lottie';
							} else if (file.type.includes('audio')) {
								filetype = 'audio';
							}

							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							const callback = async (response) => {
								const mediaUrl = response.data;
								this.mediaUrl = mediaUrl;
								this.showUploadModal = false;
								this.uploadProgress = 100;
								if (filetype === 'image') {
								// this.addMedia(file.name, 'image', mediaUrl, (file.size / oneMB));
									const reader = new FileReader();
									reader.onload = (e) => {
										const imageData = e.target.result;
										this.compressImage(imageData, `thumbnail-${filename}`, (file) => {
											this.uploadThumbnailImage(new File([file], filename), mediaUrl, (fileCallback) => {
												this.addMedia(filenameFinal, 'image', fileCallback, fileSize);
											});
										});
									};
									reader.readAsDataURL(file);
								} else if (filetype === 'video') {
									const video = new Video(file);
									const thumbnail = await video.getThumbnails({
										quality: 0.7,
										start: 0,
										end: 10,
									});
									const videoPreview = document.createElement('video');
									videoPreview.preload = 'metadata';
									videoPreview.onloadedmetadata = () => {
										window.URL.revokeObjectURL(video.src);
										const duration = videoPreview.duration;
										const blobFile = thumbnail && thumbnail.length > 0 && thumbnail[0].blob ? thumbnail[0].blob : null;
										if (blobFile) {
											this.uploadThumbnail(new File([blobFile], file.name), mediaUrl, (fileSize), duration, contentMedia);
										} else {
											const message = 'Cannot Generate Thumbnail';
											this.$notify({
												group: 'app',
												type: 'error',
												title: 'Upload Media',
												text: message,
											});
											this.tmpCount += 1;
											this.fileCount = this.fileCountTotal - (this.fileCountTotal - this.tmpCount);
											if (this.tmpCount === this.fileCountTotal) {
												this.isUploading = false;
												this.fileCount = 0;
												this.tmpCount = 0;
											}
										}
									};
									videoPreview.src = URL.createObjectURL(file);
								} else if (filetype === 'lottie') {
									this.addMedia(file.name.split('.').slice(0, -1).join('.'), 'lottie', mediaUrl, fileSize);
								} else if (filetype === 'audio') {
									this.addMedia(file.name.split('.').slice(0, -1).join('.'), 'audio', mediaUrl, fileSize);
								}
								document.querySelector('#mediaInput').value = '';
								if (this.rundownStorage) {
									// on the spot 100%
									const resultSizeFile = file.size / oneMB;
									// eslint-disable-next-line
									const isStorageOnTheSpot100 = this.rundownStorage.total_remaining_size == resultSizeFile;
									// right on 80% mark
									const resultPercentage80 = this.rundownStorage.total_max_file_size * 80 / 100;
									const fixTotalUsageAndFile80 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
									// eslint-disable-next-line
									const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.rundownStorage.total_used_file_size < resultPercentage80;
									// right on 99% mark
									const resultPercentage99 = this.rundownStorage.total_max_file_size * 99 / 100;
									const fixTotalUsageAndFile99 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
									// eslint-disable-next-line
									const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.rundownStorage.total_used_file_size < resultPercentage99;
									if (isStorageOnTheSpot100) {
										const message = 'Your total used Storage is 100%';
										this.$notify({
											group: 'app',
											type: 'warning',
											title: 'Upload Media',
											text: message,
										});
									} else if (isStorageOnTheSpot99) {
										const message = 'Your total used Storage is over 99%';
										this.$notify({
											group: 'app',
											type: 'warning',
											title: 'Upload Media',
											text: message,
										});
										this.isStorage99Percent = true;
										this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage99;
										this.availableStorage = this.rundownStorage.total_max_file_size;
									} else if (isStorageOnTheSpot80) {
										const message = 'Your total used Storage is over 80%';
										this.$notify({
											group: 'app',
											type: 'warning',
											title: 'Upload Media',
											text: message,
										});
										this.isStorage80Percent = true;
										this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage80;
										this.availableStorage = this.rundownStorage.total_max_file_size;
									}
								}
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.availableStorage = 0;
								this.currentStorage = 0;
							};
							const progressCallback = (progress) => {
								this.uploadProgress = progress;
							};
							if (filetype === 'video') {
								fileApi.uploadVideo(params, callback, errorCallback, progressCallback);
							} else {
								fileApi.upload(params, callback, errorCallback, progressCallback);
							}
						} else {
							this.tmpCount += 1;
							this.fileCount = this.fileCountTotal - (this.fileCountTotal - this.tmpCount);
							if (this.tmpCount === this.fileCountTotal) {
								this.isUploading = false;
								this.fileCount = 0;
								this.tmpCount = 0;
							}
							this.$notify({
								group: 'app',
								type: 'error',
								text: 'File already exist, please upload another file',
							});
						}
					} else {
						document.querySelector('#mediaInput').value = '';
						const appUrl = process.env.VUE_APP_URL;
						this.$notify({
							group: 'app',
							type: 'error',
							text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
						});
					}
				} else {
					document.querySelector('#mediaInput').value = '';
					this.$notify({
						group: 'app',
						type: 'error',
						text: 'Max upload limit is 1GB',
					});
				}
			} else {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Upload Media',
					text: 'Unsupported file',
				});
				// eslint-disable-next-line
				return;
			}
		},
		compressImage(result, fileName, callback) {
			const width = 160;
			const height = 90;
			const img = new Image();
			img.src = result;
			img.onload = () => {
				const elem = document.createElement('canvas');
				elem.width = width;
				elem.height = height;
				const hRatio = elem.width / img.width;
				const vRatio = elem.height / img.height;
				const ratio = Math.min(hRatio, vRatio);
				// eslint-disable-next-line
				const centerShift_x = (elem.width - img.width * ratio) / 2;
				// eslint-disable-next-line
				const centerShift_y = (elem.height - img.height * ratio) / 2;
				const ctx = elem.getContext('2d');
				// img.width and img.height will contain the original dimensions
				ctx.clearRect(0, 0, elem.width, elem.height);
				ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
				ctx.canvas.toBlob((blob) => {
					const file = new File([blob], fileName, {
						type: 'image/jpeg',
						lastModified: Date.now(),
					});
					callback(file);
				}, 'image/jpeg', 1);
			};
		},
		async uploadThumbnailImage(file, url, fileCallback) {
			const callback = (response) => {
				const mediaUrl = response.data;
				this.mediaThumbnail = mediaUrl;
				this.mediaProgress = 0;
				fileCallback(url);
				document.querySelector('#mediaInput').value = '';
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Upload Media',
					text: message,
				});
				this.isCaching = false;
				this.isCached = false;
			};
			const progressCallback = (progress) => {
				this.mediaProgress = progress;
			};

			const params = new FormData();
			params.append('file', file);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			fileApi.upload(params, callback, errorCallback, progressCallback);
		},
		uploadThumbnail(file, url, size, duration, contentMedia) {
			const params = new FormData();
			params.append('file', file);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			const callback = (response) => {
				const mediaUrl = response.data;
				this.mediaThumbnail = mediaUrl;
				this.uploadProgress = 100;
				const filenameFinal = file.name.split('.').slice(0, -1).join('.');
				this.addMedia(filenameFinal, 'video', url, size, duration, contentMedia);
				document.querySelector('#mediaInput').value = '';
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Upload Media',
					text: message,
				});
				document.querySelector('#mediaInput').value = '';
			};
			const progressCallback = (progress) => {
				this.uploadProgress = progress;
			};
			fileApi.upload(params, callback, errorCallback, progressCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
				this.updateSettingProfile();
			}, 500);
		},
		addMedia(name, type, url, size, duration, contentMedia) {
			const oneMB = 1048576; // MB
			this.isAdding = true;
			const content = {
				warningMessage: contentMedia,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name,
				path: url,
				type,
				thumbnail: this.mediaThumbnail,
				size: size / oneMB,
				duration,
			};
			if (this.categoryId !== -10) {
				params.category_id = this.categoryId;
			} else if (this.categoryId === -10) {
				params.category_id = 1;
			}
			if (this.activeRouteName === 'RundownEditor' || this.activeRouteName === 'RundownCommandEditor') {
				params.rundown_id = this.rundown.id || null;
			}
			if (type === 'video') {
				params.content = contentString;
			}
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				this.tmpCount += 1;
				this.fileCount = this.fileCountTotal - (this.fileCountTotal - this.tmpCount);
				if (this.tmpCount === this.fileCountTotal) {
					this.isUploading = false;
					this.fileCount = 0;
					this.tmpCount = 0;
				}

				this.isAdding = false;
				this.isUploadModal = false;
				this.items.unshift(item);
				document.querySelector('#mediaInput').value = '';
				this.assetsUrl = null;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isAdding = false;
			};
			// if (this.assetsUrl) {
			// 	const params = {
			// 		name: this.selected.name,
			// 		path: this.selected.path,
			// 		type: 'lottie',
			// 		thumbnail: this.selected.thumbnail,
			// 		size: this.selected.size,
			// 		assets_url: this.assetsUrl,
			// 	};
			// 	mediasApi.update(this.selected.id, params, callback, errorCallback);
			// } else {
			mediasApi.create(params, callback, errorCallback);
			// }
		},
		notifyEmailStorage() {
			const callback = () => {
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isStorage99Percent = false;
				this.isStorage80Percent = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				current_storage: this.currentStorage,
				available_storage: this.availableStorage,
			};
			mediasApi.notifyEmail(params, callback, errorCallback);
		},
		updateMedia(assetUrl) {
			this.isUploading = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				this.isUploading = false;
				this.activeLottie = `${item.path}?id=${randomString(8)}`;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				assets_url: assetUrl,
			};
			if (this.selected.description) params.description = this.selected.description;
			mediasApi.update(this.selected.id, params, callback, errorCallback);
		},
		dblCliclSelectItem(item) {
			this.selected = item;
			this.isClosed = true;
			this.$emit('select', this.selected);
		},
		selectItem(item) {
			this.notOptimizedStatus = '';
			this.isGettingMediaInfo = false;
			if (this.selected && item.id === this.selected.id) {
				this.selected = null;
			} else {
				this.selected = item;
				// to show delte button each item media
				if (this.selected.user_id === this.user.id || this.user.roles.includes('super_admin')) {
					this.isShowDelete = true;
				} else {
					this.isShowDelete = false;
				}
				if (item.type === 'lottie') {
					this.activeLottie = '';
					this.activeLottie = `${this.selected.path}?id=${randomString(8)}`;
				} else {
					this.activeLottie = '';
				}
				if (!item.description) this.isEditDescription = false;
				// getting media info
				if (item && item.type === 'video' && !item.content) {
					this.isGettingMediaInfo = true;
					if (this.isClosed) return;
					getVideoBlob(item.path).then((blob) => {
						if (this.isClosed) return;
						this.checkVideoSpec(blob, item.id);
					}).catch(() => {
						// error handling logic
						if (this.isClosed) return;
						this.$notify({
							duration: 6000,
							closeOnClick: true,
							group: 'app',
							type: 'error',
							title: 'Error getting Media',
							text: 'Error getting Media',
						});
					});
				}
			}
		},
		select() {
			this.isClosed = true;
			this.$emit('select', this.selected);
		},
		remove() {
			if (!this.selected) return;
			this.isDeleting = true;
			const id = this.selected.id;
			const selected = this.rundownItem;

			const callback = (response) => {
				this.removeItem(id);
				if (selected) {
					this.$emit('deleteMedia', selected);
				}
				this.selected = null;
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Media',
					text: message,
				});
				this.isDeleting = false;
				this.isConfirmRemoveVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Media',
					text: message,
				});
				this.isConfirmRemoveVisible = false;
				this.isDeleting = false;
			};
			mediasApi.delete(id, callback, errorCallback);
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
				document.querySelector('#mediaInput').value = '';
			}
		},
		fetchCategories() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'asc',
				type: 'media',
			};
			const callback = (response) => {
				const categories = response.data.data;
				this.categories = categories;
				const all = {
					id: -10,
					name: 'All',
				};
				this.categories.unshift(all);
			};
			const errorCallback = () => {};
			categoriesApi.getList(params, callback, errorCallback);
		},
		selectedCategory(category) {
			this.keyword = '';
			if (category.id === this.categoryId) {
				this.categoryId = -10;
				this.fetch(true);
				this.isSelectedCategory = false;
				return;
			}
			this.isSelectedCategory = true;
			this.categoryId = category.id;
			this.fetch(true);
		},
		goEvent() {
			if (this.tab === 'event') {
				this.tab = 'all';
			} else {
				this.tab = 'event';
			}
		},
		goImage() {
			if (this.tab === 'image') {
				this.tab = 'all';
			} else {
				this.tab = 'image';
			}
		},
		goVideo() {
			if (this.tab === 'video') {
				this.tab = 'all';
			} else {
				this.tab = 'video';
			}
		},
		goLottie() {
			if (this.tab === 'lottie') {
				this.tab = 'all';
			} else {
				this.tab = 'lottie';
			}
		},
		goAudio() {
			if (this.tab === 'audio') {
				this.tab = 'all';
			} else {
				this.tab = 'audio';
			}
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		showModalName(str) {
			return elpisisString(str);
		},
		// async donwloadMedia(url) {
		// 	this.isDownloading = true;
		// 	this.urlDonwload = url;
		// 	const a = document.createElement('a');
		// 	document.body.appendChild(a);
		// 	const mediaBlob = await getVideoBlob(url).catch(() => {});
		// 	if (mediaBlob) {
		// 		const url = window.URL.createObjectURL(mediaBlob);
		// 		a.href = url;
		// 		a.download = this.selected.name;
		// 		a.click();
		// 		window.URL.revokeObjectURL(url);
		// 		this.isDownloading = false;
		// 	}
		// },
		downloadMedia(url) {
			window.open(url);
		},
		onFileAssetSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'application/x-zip-compressed' || files[0].type === 'application/zip') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					const params = new FormData();
					params.append('file', file);
					if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
					// params.append('type', 'lottie');
					const callback = (response) => {
						// const mediaUrl = response.data;
						this.assetsUrl = response.data;
						// this.mediaUrl = mediaUrl;
						this.updateMedia(this.assetsUrl);
						this.uploadProgress = 0;
						document.querySelector('#assetsInput').value = '';
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media',
							text: message,
						});
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onFileThumbnailSelected(e) {
			this.isUploadingThumbnail = true;
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media Thumbnail',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					const params = new FormData();
					params.append('file', file);
					if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
					// params.append('type', 'lottie');
					const callback = (response) => {
						this.isUploadingThumbnail = false;
						// const mediaUrl = response.data;
						this.thumbnailMedia = response.data;
						// this.mediaUrl = mediaUrl;
						this.updateMediaThumbnail(this.thumbnailMedia);
						this.uploadProgress = 0;
						document.querySelector('#thumbnailInput').value = '';
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media Thummbnail',
							text: message,
						});
						this.isUploadingThumbnail = false;
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				}
			} else {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Upload Media',
					text: 'Unsupported file',
				});
				// eslint-disable-next-line
				return;
			}
		},
		updateMediaThumbnail(thumbnailData) {
			this.isUploadingThumbnail = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Thumbnail',
					text: response.message,
				});
				// recache after edit thumbnail
				const medias = this.items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie')));
				const media = medias.find(({ id }) => id === this.selected.id);
				const contentId = media.id;
				const itemKey = `thumbnail_${contentId}`;
				// eslint-disable-next-line
				localforage.getItem(itemKey, (err, value) => {
					const itemMediaThumbnail = thumbnailData;
					const itemMediaName = media && media.name ? media.name : 'media';
					if (itemMediaThumbnail && (media.type === 'image' || media.type === 'video' || media.type === 'lottie')) {
						this.cacheFile(itemKey, itemMediaThumbnail, itemMediaName);
					}
				});
				// push to UI
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.$set(this.items, index, item);
				}
				this.isUploadingThumbnail = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isUploadingThumbnail = false;
			};
			const params = {
				thumbnail: thumbnailData,
			};
			mediasApi.update(this.selected.id, params, callback, errorCallback);
		},
		sortAlphabetical() {
			this.sortBy = 'asc';
			this.orderBy = 'name';
		},
		sortRecent() {
			this.sortBy = 'desc';
			this.orderBy = 'created_at';
		},
		onResizeWidth() {
			if (window.innerWidth <= 1515 && window.innerWidth > 0) {
				this.smallButton = true;
			} else {
				this.smallButton = false;
			}
		},
		convertSize(size) {
			if (size < 1) {
				const result = size * 1000;
				return `${result.toFixed(2)} KB`;
			}
			return `${size.toFixed(2)} MB`;
		},
		openModalAssignUser(data) {
			this.isShowAssign = true;
			this.dataMediaToAssign = data;
		},
		getRundown() {
			const params = {
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
				user_id: this.user.id,
			};
			const callback = (response) => {
				const items = response.data;
				const getAllItem = {
					id: -10,
					name: 'All Event',
				};
				this.rundownList = items;
				this.rundownList.push(getAllItem);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		scroll_left() {
			const content = document.querySelector('.scrolling-horizontal-menu');
			content.scrollLeft -= 100;
		},
		scroll_right() {
			const content = document.querySelector('.scrolling-horizontal-menu');
			content.scrollLeft += 100;
		},
		dateFormat(date) {
			return dateFormat(date, 'DD/MM/YYYY HH:mm A');
		},
		setSettingsData() {
			this.isFetching = true;
			const callback = (response) => {
				const user = response.data;
				const settings = JSON.parse(user.settings);
				if (settings) {
					const settingsString = user.settings;
					const settings = JSON.parse(settingsString);
					this.settings = settings;
					this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
					this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
					this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
					this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
					this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
					this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
					this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
					this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
					this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
					this.lastRundownGallery = settings && settings.last_rundown_gallery ? duplicateVar(settings.last_rundown_gallery) : 0;
					if ((this.lastCategoryGallery !== 0 && this.rundownItem && this.rundownItem.type !== 'audio') || (this.lastCategoryGallery !== 0 && this.activeRouteName !== 'RundownEditor' && this.activeRouteName !== 'RundownCommandEditor')) {
						this.category = this.lastCategoryGallery;
						this.categoryId = this.lastCategoryGallery;
					} else {
						this.category = 'all';
					}
					if (this.lastKeywordGallery) {
						this.keyword = this.lastKeywordGallery;
					} else {
						this.keyword = '';
					}
					if (this.lastRundownGallery) {
						this.rundownFilter = this.lastRundownGallery;
					} else {
						this.rundownFilter = -10;
					}
					this.fetch();
				} else {
				// @TODO: catch variable user setting if setting is undefined
					const settingsString = user.settings;
					const settings = JSON.parse(settingsString);
					this.settings = settings;
					this.isEnableAdvance = 0;
					this.isEnableDummy = 0;
					this.isEnableAllPreview = 0;
					this.isEnableShowLogo = 0;
					this.lastCategoryGallery = this.categoryId;
					this.lastKeywordGallery = '';
					this.lastRundownGallery = -10;
					this.isShowTour = false;
					this.fetch();
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Profile',
					text: message,
				});
			};
			authApi.getProfile(callback, errorCallback);
		},
		rundownFilterUpdate(id) {
			this.rundownFilter = id;
			this.fetch(true);
			this.updateSettingProfile();
		},
		updateSettingProfile() {
			this.settings.last_category_gallery = this.categoryId;
			this.settings.last_keyword_gallery = this.keyword;
			this.settings.last_rundown_gallery = this.rundownFilter;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update Profile'),
					text: message,
				});
			};
			authApi.updateProfile(paramsSettings, callback, errorCallback);
		},
		filterByAdmin() {
			this.isByAdmin = !this.isByAdmin;
			this.fetch(true);
		},
		saveDescription() {
			this.isEditDescription = false;
			const callback = () => {
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
			};
			if (this.selected.description) params.description = this.selected.description;
			mediasApi.update(this.selected.id, params, callback, errorCallback);
		},
		regexNameExtension(str) {
			return str.substr(0, str.lastIndexOf('.')) || str;
		},
		onScrolling(e) {
			const mouseWheel = this.$refs.scrollCategory ? this.$refs.scrollCategory : '';
			const race = 80; // How many pixels to scroll
			if (e.deltaY > 0) { // Scroll right
				mouseWheel.scrollLeft += race;
			} else { // Scroll left
				mouseWheel.scrollLeft -= race;
				e.preventDefault();
			}
		},
		async checkVideoSpec(blob, mediaId) {
			if (this.selected && this.selected.type === 'image') return;
			if (this.selected && this.selected.id === mediaId) {
				this.isGettingMediaInfo = true;
			}
			const getSize = () => blob.size;
			const readChunk = (chunkSize, offset) => new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (event) => {
					if (event.target.error) {
						reject(event.target.error);
					}
					resolve(new Uint8Array(event.target.result));
				};
				reader.readAsArrayBuffer(blob.slice(offset, offset + chunkSize));
			});
			// eslint-disable-next-line no-undef
			MediaInfo({ format: 'JSON' }, (mediainfo) => {
				mediainfo.analyzeData(getSize, readChunk)
					.then((result) => {
						const info = result && result.length > 0 ? JSON.parse(result) : null;
						const tracks = info && info.media && info.media.track ? info.media.track : null;
						const trackIndex = tracks.findIndex(track => track['@type'] === 'Video');
						if (trackIndex !== -1) {
							const mb5 = 5000000; /* 5Mbps */
							if ((tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is exceeding the recommended limit for Web Playback, recomended bitrate is lower than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
							} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is larger than 1920 x 1080, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
							} else if ((tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is larger than 1920 x 1080 and bitrate is larger than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
							} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								// when track is valid
								this.notOptimizedStatus = 'No performance issue';
							}
						}
						// after getting information immediately saving it to media content
						const callback = (response) => {
							const item = response.data;
							// push to UI
							const index = this.items.findIndex(({ id }) => id === item.id);
							if (index !== -1) {
								this.$set(this.items, index, item);
								if (this.selected && this.selected.id === item.id) {
									this.selected = item;
									this.isGettingMediaInfo = false;
								}
							}
						};
						const errorCallback = (e) => {
							const message = getAxiosErrorMessage(e);
							this.$notify({
								group: 'app',
								type: 'error',
								title: 'Update Media',
								text: message,
							});
							this.isGettingMediaInfo = false;
						};
						const content = {
							warningMessage: this.notOptimizedStatus,
						};
						const contentString = JSON.stringify(content);
						const params = {
							content: contentString,
						};
						mediasApi.update(mediaId, params, callback, errorCallback);
					})
					.catch(() => {
						// console.log(error);
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'cannot read your video meta data info',
						});
						this.isGettingMediaInfo = false;
					});
			});
		},
		// eslint-disable-next-line
		getMediaInfo(data) {
			let content = data && data.content ? data.content : '';
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			const result = content && content.warningMessage ? content.warningMessage : '';
			if (result !== 'No performance issue') {
				return result;
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		isVirtualCam() {
			return (this.rundownItem && this.rundownItem.type ? this.rundownItem.type : '') === 'virtual_cam';
		},
		isAudio() {
			return (this.rundownItem && this.rundownItem.type ? this.rundownItem.type : '') === 'audio';
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		userStorage() {
			return {
				total: this.user && this.user.storage && this.user.storage.total ? this.user.storage.total : 0,
				total_remaining: this.user && this.user.storage && this.user.storage.total_remaining ? this.user.storage.total_remaining : 0,
				total_usage: this.user && this.user.storage && this.user.storage.total_usage ? this.user.storage.total_usage : 0,
			};
		},
		mediaType() {
			let type = 'image';
			if (this.mediaFile && this.mediaFile.type.includes('video')) {
				type = 'video';
			} else if (this.mediaFile && this.mediaFile.type.includes('json')) {
				type = 'lottie';
			}
			return type;
		},
		activeRouteName() {
			return this.$route.name;
		},
		loadingCache() {
			if (this.cachingText.includes('Loading')) {
				return `${this.cachingText}...`;
			}
			return `${this.cachingText}...`;
		},
		rundownFilterLabel() {
			if (this.rundownList) {
				const index = this.rundownList.findIndex(({ id }) => id === this.rundownFilter);
				if (index !== -1) return this.rundownList[index].name;
			}
			return 'Current Rundown';
		},
	},
	created() {
		this.fetchCategories();
		this.setSettingsData();
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.getRundown();
		this.isClosed = false;
	},
	watch: {
		rundownFilter() {
			this.updateSettingProfile();
		},
		sortBy() {
			this.fetch(true);
		},
		categoryId() {
			this.updateSettingProfile();
		},
		user() {
			if (this.user) {
				// this.setSettingsData();
			}
		},
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		// scroll horizontal with scroll wheel
		const mouseWheel = this.$refs.scrollCategory ? this.$refs.scrollCategory : '';
		mouseWheel.addEventListener('wheel', this.onScrolling);
	},
};
</script>

<style>
.gallery-modal .modal-body {
	min-height: 589px;
	/* max-height: 1080px; */
}
.gallery-modal-delete .modal-body {
	min-height: 70px;
	/* max-height: 1080px; */
}
</style>
